module.exports = __webpack_public_path__ + "img/hiroshima_1.fd6be944.jpg";